
import { Link } from "react-router-dom";
import { useRef, useState, useEffect,useLayoutEffect } from "react";

// menu component
const Menu = ({ items }) => {
  const [activeLink, setActiveLink] = useState(null);
  const location = useRef(null);

  const handleScrollToLink = (event) => {
    event.preventDefault();
    const targetId = event.target.href.split('#')[1];
    const targetElement = document.getElementById(targetId);
    window.location.href = event.target.href
    if (targetElement) {
      window.scrollTo({ top: targetElement.offsetTop - 200, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    location.current = window.location.href;
  }, []);

  useEffect(() => {
    if (location.current !== window.location.href) {
      setActiveLink(null);
      location.current = window.location.href;
    }
  }, [window.location.href]);

  useEffect(() => {
    const handleScroll = () => {
      items.forEach((item) => {
        if (item.ref_link_href && item.ref_link_href.includes('#')) {
          const sectionId = item.ref_link_href.split('#')[1];
          const targetElement = document.getElementById(sectionId);
          if (targetElement !== null) {
            if (window.scrollY >= targetElement.offsetTop - 200) {
              setActiveLink(item);
            }
          }
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [items]);

  useLayoutEffect(() => {
    const currentHash = window.location.hash;
    if (currentHash && items.some((item) => item.ref_link_href.includes(currentHash))) {
      const targetId = currentHash.split('#')[1];
      const targetElement = document.getElementById(targetId);
      if (targetElement !== null) {
        setActiveLink(items.find((item) => item.ref_link_href.includes(currentHash)));
        window.scrollTo({ top: targetElement.offsetTop - 200, behavior: 'smooth' });
      }
    } else if (window.location.pathname === '/') {
      const homeItem = items.find((item) => item.ref_link_href === '/');
      if (homeItem) {
        setActiveLink(homeItem);
      }
    }
  }, [items, window.location.hash]);

  return (
    <>
      <ul className="navbar-nav ml-auto">
        {items.map((item) => (
          <li key={item.title} className={`nav-item main-menu ${activeLink === item ? 'active' : ''}`}>
            <Link
              className="nav-link"
              to={{
                pathname: item.ref_link_href?.includes("") ? "/" : item.ref_link_href,
                hash: item.ref_link_href?.includes("#") ? item.ref_link_href : ""
              }}
              target={item._type !== 'linkInternal' ? '_blank' : null}
              onClick={(event) => handleScrollToLink(event)}
            >{item.title}</Link>
            {item.submenu && (
              <ul className="sub-menu navbar-nav ml-auto">
                {item.submenu.map((submenuItem) => (
                  <li key={submenuItem.id} className="nav-item">
                    <a className="nav-link">{submenuItem.label}</a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </>
  );
};

export default Menu;